export default {
    create_account_btn: 'إنشاء حساب',
    globals: {
        more_platforms: 'مزيد من المنصات قادمة قريبا.',
        coming_soon: 'قريباً',
    },
    buttons:{
        edit: 'تعديل',
        delete: 'حذف',
    },
    alerts: {
        info: {
            part_one: 'هنا يمكنك ربط حسابات المستودعات الخاصة بك بشبكات الشركاء ومراكز التنفيذ المدعومة، لإرسال طلباتك إليهم تلقائيًا عبر واجهة برمجة التطبيقات. يمكنك ربط مستودع واحد بمنصة واحدة عبر واجهة برمجة التطبيقات. يرجى الاطلاع على',
            part_two: 'هذا البرنامج التعليمي',
            part_three: 'أو مزيد من المعلومات.',
        }
    },
    sdks: {
        cod_network: {
            title: 'COD Network (Seller/Drop)',
            fields: {
                affiliate_api_key: {
                    title: 'Affiliate API Key',
                    placeholder: 'Paste API Key here'
                },
                seller_api_token: {
                    title: 'Seller API Token',
                    placeholder: 'Paste API Token here'
                }
            },
            notes: {
                lead_info: 'Webhook for leads',
                order_info: 'Webhook for orders',
            }
        },
        eco_manager: {
            title: 'ecomanager.dz (Algeria)',
            fields: {
                store_name: {
                    title: 'Store Name',
                    placeholder: 'Your store name'
                },
                token: {
                    title: 'Bearer token',
                    placeholder: 'Paste token here'
                },
                send_order_on: {
                    title: 'Send order On',
                    placeholder: 'Send order On',
                    options: {
                        pending: 'Pending',
                        confirmed: 'Confirmed',
                    }
                },
                wilaya: {
                    title: 'Wilaya Name (optional)',
                    placeholder: 'The Wilaya Name'
                },
                commune: {
                    title: 'Commune Name (optional)',
                    placeholder: 'The Commune Name'
                }
            }
        },
        islaffiliate: {
            title: 'Islaffiliate - Affiliate Network',
            fields: {
                api_key: {
                    title: 'X-API-KEY',
                    placeholder: 'Paste API Key here',
                },
                user_id: {
                    title: 'X-USER-ID',
                    placeholder: 'Paste User Id here',
                },
            }
        },
        offersify: {
            title: 'Offersify - Affiliate Network',
            fields: {
                api_key: {
                    title: 'X-API-KEY',
                    placeholder: 'Paste API Key here',
                },
                user_id: {
                    title: 'X-USER-ID',
                    placeholder: 'Paste User Id here',
                },
            }
        },
        afrique_cod: {
            title: 'AfriqueCOD (Seller)'
        },
        cod_in_africa: {
            title: 'CODInAfrica (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        prime_cod: {
            title: 'PrimeCOD (Seller/Drop)',
            fields: {
                token: {
                    title: 'Bearer token',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        ship_box: {
            title: 'ShipBox (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
        shipsen: {
            title: 'Shipsen (Seller)',
            fields: {
                api_key: {
                    title: 'Api Key',
                    placeholder: 'XXXXXXXXXX'
                },
                api_key_secret: {
                    title: 'Api Secret',
                    placeholder: 'XXXXXXXXXX'
                }
            }
        },
    },
    table: {
        account_id: 'معرف الحساب',
        account_name: 'إسم الحساب',
        account_role: 'دور الحساب',
        sdk_name: 'إسم الAPI',
        actions: 'خيارات'
    },
    dialogs: {
        delete: {
            title: '',
            content: ''
        }
    },
    form: {
        update_account: {
            title: 'تعديل الحساب'
        },
        create_account: {
            title: 'إنشاء الحساب'
        },
        fields: {
            account: {
                title: 'الحساب',
                placeholder: 'إختر إسم للحساب',
            },
            sdk: {
                title: 'ال Api'
            },
            auth_data: {
                title: 'بيانات التفويض *'
            },
            settings: {
                options: {
                    bearer: {
                        content: {
                            title: 'Bearer Token'
                        }
                    },
                    basic: {
                        username: {
                            title: 'إسم المستخدم'
                        },
                        password: {
                            title: 'كلمة السر'
                        }
                    }
                }
            },
            custom_data: {
                title: 'البيانات المخصصة',
                form: {
                    key_value: {
                        title: 'قائمة المفاتيح/القيم',
                        item: {
                            title: 'المفاتيح/القيم',
                            form: {
                                key: {
                                    title: 'مفتاح'
                                },
                                type: {
                                    options: {
                                        text: 'نص',
                                        list: 'قائمة'
                                    }
                                },
                                value: {
                                    title: 'قيمة'
                                }
                            }
                        },
                        alert: 'لم يتم إضافة أي قيمة',
                        button_add: 'إضافة'
                    }
                }
            },
            notes: {
                title: 'ملاحظات',
                no_notes: 'لم يتم العثور على أي ملاحظات في هذا ال API',
                no_sdk: 'لم يتم تحديد أي API'
            }
        },
        create_btn: 'إنشاء الحساب',
        save_btn: 'حفظ الحساب',
        cancel_btn: 'إلغاء',
    }
}